module.exports = __webpack_public_path__ + "static/img/banner_init.a650dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/banner_init.png
// module id = iStK
// module chunks = 0